import React, {AriaAttributes, CSSProperties, ReactNode} from 'react'

import {Info, P} from '../index.js'
import {controlLabel} from './choiceStyles.js'

// role, tabIndex, aria-* and onKeyDown are passed on, for a label that acts as the control itself (RadioButton)
export interface ControlLabelProps extends AriaAttributes {
    children?: ReactNode
    info?: ReactNode
    disabled?: boolean
    style?: CSSProperties
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
    onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void
    role?: string
    tabIndex?: number
}

/** The label of a non-text control (check, toggle, slider, upload...), next to or above the control */
const ControlLabel = ({children, info, disabled, style, onClick, ...rest}: ControlLabelProps) => {
    const labelStyle: CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        fontSize: controlLabel.fontSize,
        fontWeight: controlLabel.fontWeight,
        letterSpacing: controlLabel.letterSpacing,
        lineHeight: controlLabel.lineHeight,
        color: disabled ? controlLabel.colorDisabled : controlLabel.color,
        ...style
    }

    return (
        <P style={labelStyle} disabled={disabled} onClick={onClick} {...rest}>
            {children}
            {/* Hovering or clicking the info icon shouldn't do what clicking the label does */}
            {info && (onClick ? <span onClick={(event) => event.stopPropagation()}><Info style={{marginLeft: 6}} text={info} /></span> : <Info style={{marginLeft: 6}} text={info} />)}
        </P>
    )
}

export default ControlLabel
